import { SnackbarProps } from '@mui/material';

export enum SnackbarSeverity {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
}

export type SnackbarMessage = {
  message: string;
  key?: string;
  severity?: SnackbarSeverity;
  snackbarProps?: SnackbarProps;
};

export type SnackbarContextType = {
  snack: (options: string | SnackbarMessage) => void;
};
